import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import { EVENT_REMINDER_OPTIONS } from 'lib/utils/store/event'

import { FieldArray } from 'formik'
import Button from 'components/UI/Button'
import EventReminderItem from './EventReminderItem/EventReminderItem'

import './event-reminders.pcss'

const MAX_REMINDER_COUNT = 4

const EventReminders = ({ t, fieldName }) => {
    const { values } = useContext(ExtendedFormikContext)

    const remindBefore = values[fieldName]

    const handleAddReminder = (arrayHelpers) => {
        let value = EVENT_REMINDER_OPTIONS[0].value

        // pick next option from reminders
        const latestValue = remindBefore[remindBefore.length - 1]
        const latestIndex = EVENT_REMINDER_OPTIONS.findIndex(option => option.value === latestValue)

        if (latestIndex < EVENT_REMINDER_OPTIONS.length - 1) {
            value = EVENT_REMINDER_OPTIONS[latestIndex + 1].value
        }

        return arrayHelpers.push(value)
    }

    return (
        <div className="event-reminders">
            <FieldArray
                name={fieldName}
                render={arrayHelpers => (
                    <>
                        <div className="label-and-description">
                            <label>{t('events:reminders.remindMe')}</label>
                        </div>
                        <div className="event-reminders__items">
                            {remindBefore.map((reminder, index) => (
                                <EventReminderItem
                                    key={index}
                                    fieldName={fieldName}
                                    reminder={reminder}
                                    index={index}
                                    onRemove={arrayHelpers.remove}
                                    removeDisabled={remindBefore.length <= 1}
                                />
                            ))}
                        </div>
                        <div className="event-reminders__actions">
                            {remindBefore.length < MAX_REMINDER_COUNT && (
                                <Button
                                    trackName="addReminder"
                                    type="button"
                                    className="button button--tertiary"
                                    onClick={() => handleAddReminder(arrayHelpers)}
                                >
                                    {`+ ${t('events:reminders.addReminder')}`}
                                </Button>
                            )}
                        </div>
                        <div className="event-reminders__tip">
                            <span>{t('events:reminders.reminderSendInfo')}</span>
                        </div>
                    </>
                )}
            />
        </div>
    )
}

EventReminders.propTypes = {
    t: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
}

export default withTranslationCustom('events')(EventReminders)
